import { render, staticRenderFns } from "./isDeleted.vue?vue&type=template&id=57680b12"
import script from "./isDeleted.vue?vue&type=script&lang=js"
export * from "./isDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports